import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { env } from "@/env/client";

const INTERCOM_ENABLED_PAGES = ["/", "/dashboard", "/subscription"];

export const useIntercom = () => {
  const pathname = usePathname();
  const [showIntercom, setShowIntercom] = useState(false);

  useEffect(() => {
    // Handle the case when pathname is null
    if (!pathname) return;

    // Normalize the pathname
    const normalizedPathname =
      pathname === "/"
        ? "/"
        : pathname.endsWith("/")
          ? pathname.slice(0, -1)
          : pathname;

    // Check if the normalized pathname is in the INTERCOM_ENABLED_PAGES array
    const shouldShowIntercom =
      INTERCOM_ENABLED_PAGES.includes(normalizedPathname);

    setShowIntercom(shouldShowIntercom);

    if (shouldShowIntercom) {
      // Initialize Intercom
      if (typeof window !== "undefined" && window.Intercom) {
        window.Intercom("boot", {
          api_base: "https://api-iam.intercom.io",
          app_id: env.NEXT_PUBLIC_INTERCOM_APP_ID,
          hide_default_launcher: false, // Ensure the launcher is visible
        });
      }
    } else {
      // Shutdown Intercom
      if (typeof window !== "undefined" && window.Intercom) {
        window.Intercom("shutdown");
      }
    }
  }, [pathname]);

  return showIntercom;
};
